import { SuperText } from '../styles';

export const SuperTextElement = ({
  text,
  id,
  textColor,
}: {
  text: string;
  id: string;
  textColor?: 'Black' | 'White';
}) => {
  return (
    <SuperText
      tag="p"
      type="lead"
      data-test={`${id}-super-text`}
      $color={textColor}
      className="super-text-banner"
    >
      {text}
    </SuperText>
  );
};
